const icon = (
	<svg
		height="20px"
		width="20px"
		xmlns="http://www.w3.org/2000/svg"
		version="1.1"
		viewBox="0 0 16 16"
	>
		<path
			d="M14 4v-2h-14v13h16v-11h-2zM10 3h3v1h-3v-1zM6 3h3v1h-3v-1zM15 14h-14v-11h4v2h10v9z"
			fill="#f64646"
		/>
	</svg>
);

export const horizontalTabIcon = (
	<svg
		height="20px"
		width="20px"
		xmlns="http://www.w3.org/2000/svg"
		version="1.1"
		viewBox="0 0 16 16"
	>
		<path d="M14 4v-2h-14v13h16v-11h-2zM10 3h3v1h-3v-1zM6 3h3v1h-3v-1zM15 14h-14v-11h4v2h10v9z" />
	</svg>
);

export const verticalTabIcon = (
	<svg
		height="20px"
		width="20px"
		xmlns="http://www.w3.org/2000/svg"
		version="1.1"
		viewBox="0 0 16 16"
	>
		<path
			d="M14 4v-2h-14v13h16v-11h-2zM10 3h3v1h-3v-1zM6 3h3v1h-3v-1zM15 14h-14v-11h4v2h10v9z"
			transform="rotate(-90, 8, 8) scale(-1,1) translate(-16, 0)"
		/>
	</svg>
);

export const accordionIcon = (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="20"
		height="20"
		viewBox="0 0 16 16"
	>
		<path d="M0 4v8h16v-8h-16zM15 11h-14v-4h14v4z" />
		<path d="M0 0h16v3h-16v-3z" />
		<path d="M0 13h16v3h-16v-3z" />
	</svg>
);

export default icon;
